import { InstallmentStatusEnum, type Installment } from "@/generated/types";
import { TableRow, TableCell } from "@/components/ui/table";
import Currency from "../Currency";
import DateDisplay from "../DateDisplay";

interface InstallmentRowProps {
  installment: Installment;
}

export default function InstallmentRow({ installment }: InstallmentRowProps) {
  const isPaid = installment.status === InstallmentStatusEnum.Paid;
  const isOverdue = installment.status === InstallmentStatusEnum.Overdue;

  return (
    <TableRow>
      <TableCell className="w-16">
        <span className="text-sm text-primary-600 dark:text-primary-400">
          #{installment.number.toString().padStart(2, "0")}
        </span>
      </TableCell>
      <TableCell>
        <Currency value={installment.amount} />
      </TableCell>
      <TableCell>
        <DateDisplay
          date={installment.dueDate}
          className={isOverdue ? "text-red-600" : undefined}
        />
      </TableCell>
      <TableCell>
        {isPaid && (
          <DateDisplay
            date={installment.paidAt}
            className="font-medium text-green-600"
          />
        )}
      </TableCell>
    </TableRow>
  );
}
